var _circle, _circle2, _g, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnonymous = function SvgAnonymous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#ECECEC",
    stroke: "#A5A4A8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "anonymous_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#ECECEC",
    stroke: "#A5A4A8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#anonymous_svg__a)",
    fill: "#fff",
    stroke: "#A5A4A8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.532 22.36-.028-.017C1.654 16.674 6.295 12.125 12 12.125s10.347 4.55 10.496 10.218l-.028.017a37.712 37.712 0 0 1-3.41 1.747C16.907 25.068 14.238 26 12 26c-2.238 0-4.907-.93-7.058-1.894a37.703 37.703 0 0 1-3.41-1.746Z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#A5A4A8"
  })));
};
export default SvgAnonymous;